var path = 'app/scripts/modules/core/src/pipeline/config/pipelineConfigView.html';
var html = "<div class=\"row\">\n  <div class=\"col-md-12\">\n    <triggers ng-if=\"viewState.section === 'triggers'\"\n              application=\"application\"\n              pipeline=\"pipelineConfig\">\n    </triggers>\n    <pipeline-config-stage ng-if=\"viewState.section === 'stage'\"\n                           application=\"application\"\n                           view-state=\"viewState\"\n                           pipeline=\"pipeline\">\n    </pipeline-config-stage>\n  </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/core/src/pipeline/config/pipelineConfigView.html
// module id = 1045
// module chunks = 0